import {
  faCheckCircle,
  faTimesCircle,
} from '@fortawesome/pro-regular-svg-icons';
import { faUser } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { UserContext } from '../../../../stores';
import {
  ErrorMessage,
  FormContent,
  FormContentGroup,
  FormHeading,
  InputContainer,
  ResponseText,
  StyledButton,
  SuccessMessage,
} from '../styles';

function ForgotPassword() {
  const [usernameValue, setUsernameValue] = useState('');
  const handleUsernameChange = (e) => setUsernameValue(e.target.value);
  const [error, setError] = useState('');
  const [responseText, setResponseText] = useState('');

  const userStore = useContext(UserContext);

  const onPressSendRecoveryEmail = async (event) => {
    event.preventDefault();
    setError('');

    if (usernameValue.length < 1) {
      setError('Username field is empty.');
      return;
    }

    try {
      await userStore.sendPasswordReset(usernameValue);
      setResponseText(
        `Een e-mail is verzonden naar het e-mailadres verbonden met gebruikersaccount ${usernameValue}`
      );
    } catch (e) {
      setError(
        'Wachtwoord resetten is mislukt. Dit account bestaat mogelijk niet.'
      );
    }
  };

  return (
    <React.Fragment>
      <FormHeading>
        <FormattedMessage id="pages/Login/LoginFormSection/ForgetPassword" />
      </FormHeading>

      <form onSubmit={onPressSendRecoveryEmail}>
        <FormContent>
          <FormContentGroup>
            <label>
              <FormattedMessage id="pages/Login/LoginFormSection/UsernameLabel" />
            </label>
            <InputContainer>
              <FontAwesomeIcon icon={faUser} />
              <input
                name="username"
                value={usernameValue}
                onChange={handleUsernameChange}
              />
            </InputContainer>
            {responseText && (
              <SuccessMessage>
                <FontAwesomeIcon icon={faCheckCircle} />
                <ResponseText>{responseText}</ResponseText>
              </SuccessMessage>
            )}
            {error && (
              <ErrorMessage>
                <FontAwesomeIcon icon={faTimesCircle} />
                <ResponseText>{error}</ResponseText>
              </ErrorMessage>
            )}
          </FormContentGroup>

          <StyledButton onClick={onPressSendRecoveryEmail}>
            <FormattedMessage id="pages/Login/ForgetPassword/SendEmail" />
          </StyledButton>
        </FormContent>
      </form>
    </React.Fragment>
  );
}

export default injectIntl(ForgotPassword);
